// extracted by mini-css-extract-plugin
export default {"buttonPic":"MyImageButton_buttonPic__azIN9","absoluteImg":"MyImageButton_absoluteImg__45qnp"};